import { gql } from '@apollo/client';

export const GET_CATEGORIES = gql`
  query getFlyerCategories {
    getFlyerCategories {
      id
      title
      icon
    }
  }
`;
